'use client';

import type React from 'react';

import { Video, FileText, ClipboardList, PenTool, Award } from 'lucide-react';
import { Button } from 'components/ui/button';
import { Card, CardContent } from 'components/ui/card';
import { CertificateSelectionStep } from './certificate-selection-step';
import { VideoStep } from './video-step';
import { ContentStep } from './content-step';
import { FinalStep } from './final-step';
import { useCertification } from '../contexts/certification-context';
import { CertificationProgress } from './certification-progress';

export interface CertificateType {
  id: string;

  title: string;
  description: string;
  duration: string;
  videoId: string;
  requirements: string[];
  quizQuestions: QuizQuestion[];
  steps: {
    [key: number]: {
      title: string;
      icon: React.ReactNode;
      videoId?: string;
      content?: any;
      stepTitle?: string;
      component: React.ReactNode;
      videoExplain?: React.ReactNode;
      validation?: 'video' | 'content';
    };
  };
}

export interface QuizQuestion {
  id: number;
  text: string;
  options: { id: string; text: string }[];
  correctAnswer: string;
}

type Step = {
  id: number;
  // title: string;
  icon: React.ReactNode;
  component: React.ReactNode;
};

export function CertificationWizard() {
  const {
    selectedCertificate,
    videosCompleted,
    contentsReviewed,
    quizCompleted,
    signature,
    userName,
    currentStep,
    setCurrentStep,
    totalSteps,
  } = useCertification();

  // const steps: Step[] = [
  //   {
  //     id: 1,
  //     // title: 'Select Certificate',
  //     icon: <Award className="h-4 w-4" />,
  //     component: <CertificateSelectionStep />,
  //   },
  //   {
  //     id: 2,
  //     // title: 'Watch Video',
  //     icon: <Video className="h-4 w-4" />,
  //     component: <VideoStep key={2} step={2} />,
  //   },
  //   {
  //     id: 3,
  //     // title: 'Review Content',
  //     icon: <FileText className="h-4 w-4" />,
  //     component: <ContentStep />,
  //   },
  //   {
  //     id: 4,
  //     // title: 'Watch Video',
  //     icon: <Video className="h-4 w-4" />,
  //     component: <VideoStep key={4} step={4} />,
  //   },
  //   {
  //     id: 5,
  //     // title: 'Complete Quiz',
  //     icon: <Video className="h-4 w-4" />,
  //     component: <VideoStep key={5} step={5} />,
  //   },
  //   {
  //     id: 6,
  //     // title: 'Sign & Get Certificate',
  //     icon: <PenTool className="h-4 w-4" />,
  //     component: <FinalStep />,
  //   },
  // ];

  const handleNext = () => {
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };

  const isNextDisabled = () => {
    if (
      selectedCertificate?.steps[currentStep]?.validation === 'content' &&
      !contentsReviewed.includes(currentStep)
    ) {
      return true;
    }
    if (
      selectedCertificate?.steps[currentStep].validation === 'video' &&
      !videosCompleted.includes(currentStep)
    ) {
      return true;
    }

    // if (currentStep === 4 && !quizCompleted) return true;
    return false;
  };

  // if (!selectedCertificate?.steps) return null;

  const steps = selectedCertificate
    ? Object.entries(selectedCertificate.steps).map(([id, step]) => {
        return {
          id: parseInt(id),
          ...step,
        };
      })
    : [];

  return (
    <div className="space-y-8">
      {/* Progress Indicator */}
      <CertificationProgress currentStep={currentStep} />

      {/* Step Content */}
      <Card>
        <CardContent className="pt-6">
          {selectedCertificate ? (
            selectedCertificate?.steps[currentStep]?.component
          ) : (
            <CertificateSelectionStep />
          )}
        </CardContent>
      </Card>
      {/* <pre>{JSON.stringify(videosCompleted, null, 2)}</pre> */}
      {/* Navigation */}
      <div className="flex justify-end">
        {currentStep < steps.length && (
          <Button onClick={handleNext} disabled={isNextDisabled()}>
            Næste
          </Button>
        )}
      </div>
    </div>
  );
}
